import { UUID } from "@screencloud/uuid";
import { appConfig } from "src/appConfig";

export const createAppConfig = async (signedToken: string): Promise<string> => {
  const createAppConfigRes = await fetch(
    appConfig.platform.connectionsUrl + `/create-app-config?appName=quickpost`,
    {
      headers: {
        Authorization: `Bearer ${signedToken}`,
        "Content-Type": "application/json",
      },
      method: "POST",
    },
  );

  if (!createAppConfigRes.ok) {
    throw new Error(
      `Failed to create app config: ${createAppConfigRes.statusText}`,
    );
  }

  return (await createAppConfigRes.json()).data.appConfigId;
};

export const createHook = async (
  signedToken: string,
  appConfigId: string,
): Promise<{ hookId: UUID; feedId: UUID }> => {
  const createHookRes = await fetch(appConfig.platform.feedsUrl + `/hooks`, {
    body: JSON.stringify({
      appName: "quickpost",
      provider: "Webhook",
      appConfigId,
    }),
    headers: {
      Authorization: `Bearer ${signedToken}`,
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  if (!createHookRes.ok) {
    throw new Error(`Failed to create hook: ${createHookRes.statusText}`);
  }

  const createHookResJson = await createHookRes.json();
  return {
    hookId: createHookResJson.data.hookId,
    feedId: createHookResJson.data.feedId,
  };
};
